<div>
  <p-dropdown [options]="years" (onChange)="updateList($event.value)">
  </p-dropdown>
</div>
<p-table [value]="invoicesToValidate">
    <ng-template pTemplate="header">
        <tr>
         <th>Booking id</th>
         <th>
          Invoice num.
         </th>
          <th>date</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-invoice>
        <tr [pSelectableRow]="invoice">
            <td>
              <a [href]="baseUrl + '/management/edit-booking/' + invoice.bookingId" target="_blank">
                {{invoice.bookingId}}
              </a>
            </td>
            <td>
              {{invoice.invoiceNumber}}
            </td>
            <td>
                {{invoice.date.format('DD/MM/YYYY')}}
            </td>
        </tr>
      </ng-template>
</p-table>